import React, { FC } from 'react';

import { useBankregnr, useConfig, useData } from '../config';
import { logger } from '../logg/logger';
import { DeveloperPage } from '../test/developer-page';
import { Skademeldingstype } from '../types/generated-types';

const Landingsside: FC = () => {
    const developerPageEnabled = useData('developerpageenabled');
    const bankregnr = useBankregnr();
    const { url } = useConfig().links.meldskadelandingsside;

    if (developerPageEnabled) {
        return <DeveloperPage />;
    }

    const log = logger(bankregnr);
    log.warn(
        `Kunde har landet på blank side, kunde kom fra "${document.referrer}". Nåværende url er: "${window.location.href}".`,
        '',
        Skademeldingstype.Annet,
        null,
    );

    window.location.href = url;

    return <div />;
};

export default Landingsside;
